<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-content-wrap">
      <section>
        <div class="boss-layout boss-layout-vertical boss-layout-vertical-gap-large">
          <div class="boss-page-title-layout">
            <div>
              <h1 class="boss-page-title boss-page-title-layout-title">
                セミナー管理
              </h1>
            </div>
            <seminar-entry-display-target
              :entry-objects="entryObjects"
              @setDisplayTargets="setDisplayTargets"
              @filteredUpdate="setEntryObjects"
            />
          </div>
          <seminar-entry-filter
            :entry-objects="entryObjects"
            @filteredUpdate="setEntryObjects"
          />
          <div class="boss-batch-container clearfix padding-top-0">
            <div class="float-left boss-check-container">
              全
              <span
                class="boss-check-number"
                data-test="displayed-count"
              >{{ isLoading ? '...' : displayedCount }}</span>名
            </div>
            <seminar-entry-bulk-update
              :entry-ids="checkedEntryIds"
              :select-limit="selectLimit"
              data-test="bulk-update"
              @updated="fetch"
            />
          </div>
          <div
            id="entry-entries"
            data-test="entry-entry-wrap"
            class="boss-table-wrap"
          >
            <seminar-entry-entries
              ref="entryEntries"
              :display-target="displayTargets"
              :entry-objects="entryObjects"
              :select-limit="selectLimit"
              @fetch="fetch"
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import SeminarEntryFilter from '@/components/molecules/SeminarEntryFilter'
import SeminarEntryDisplayTarget from '@/components/molecules/SeminarEntryDisplayTarget'
import SeminarEntryBulkUpdate from '@/components/molecules/SeminarEntryBulkUpdate'
import _ from 'lodash'
import SeminarEntryEntries from '@/components/organisms/SeminarEntryEntries'
import Indicator from '@/lib/indicator'

export default {
  name: 'SeminarEntryTop',
  components: {
    SeminarEntryEntries: SeminarEntryEntries,
    SeminarEntryDisplayTarget: SeminarEntryDisplayTarget,
    SeminarEntryFilter: SeminarEntryFilter,
    SeminarEntryBulkUpdate: SeminarEntryBulkUpdate
  },
  data () {
    return {
      entryObjects: [],
      // 子コンポーネントに表示対象者を渡すために追加
      displayTargets: [],
      isFetchCallForActivated: false,
      count: 0
    }
  },
  computed: {
    checkedEntryIds () {
      return _(this.entryObjects).filter('isChecked').map(_.property('entry.id')).value()
    },
    renderingEntryObjects () {
      return _(this.entryObjects)
        .filter('isShow')
        .filter('isDisplayTarget')
        .value()
    },
    displayedCount () {
      return this.isLoading ? null : this.renderingEntryObjects.length
    },
    selectLimit: () => 2000,
    isLoading: () => Indicator.getLoadingStatus()
  },
  created () {
    this.fetch()
  },
  activated () {
    this.isFetchCallForActivated && this.fetch()
  },
  deactivated () {
    this.$set(this, 'isFetchCallForActivated', true)
  },
  methods: {
    fetch () {
      Indicator.emitShow()
      this.fetchEntries()
      Indicator.emitHide()
    },
    fetchEntries () {
      this.$http.secured.get('/seminar/entries')
        .then((response) => {
          this.setProperty(response.data)
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    setProperty (entries) {
      this.$set(this, 'entryObjects', _(entries).map(entry => {
        return {
          isShow: true,
          isDisplayTarget: true,
          isChecked: false,
          entry: entry
        }
      }).value())
    },
    setEntryObjects (entryObjects) {
      this.$set(this, 'entryObjects', entryObjects)
    },
    setDisplayTargets (displayTargets) {
      this.$set(this, 'displayTargets', displayTargets)
    }
  }
}
</script>
